module.exports = __webpack_public_path__ + "static/media/abdata_favicon.68074bd5.ico";